import { render, staticRenderFns } from "./insertPDFDialog.vue?vue&type=template&id=483f1e20&scoped=true&"
import script from "./insertPDFDialog.vue?vue&type=script&lang=js&"
export * from "./insertPDFDialog.vue?vue&type=script&lang=js&"
import style0 from "./insertPDFDialog.vue?vue&type=style&index=0&id=483f1e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483f1e20",
  null
  
)

export default component.exports